import React, { useEffect, useState, useRef, useMemo } from "react";
import EditIcon from "@material-ui/icons/Edit";
import { makeStyles, Grid, Box } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";

import PipelineRates from "./PipelineRates";
import PLStatement from "./PLStatement";
import { getListOfOpportunityAPI } from "../../../api/financial-management-api";
import Loading from "../../../common-components/Loading";
import ActionMessages from "../../../common-components/ActionMessages";

const useStyles = makeStyles((theme) => ({}));

const Pipeline = ({
  isAddOpp,
  setIsAddOpp,
  showOpportunityDetails,
  onFilteredOppNosChange,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [showDialogViewRates, setShowDialogViewRates] = useState(false);
  const [tableEditable, setTableEditable] = useState(false);
  const [plData, setPlData] = useState();
  const [loading, setLoading] = useState(false);
  const [emptyErrMsg, setEmptyErrMsg] = useState(false);
  const [msgType, setMsgType] = useState();
  const [msgText, setMsgText] = useState();
  const [loadOpp, setLoadOpp] = useState(false);
  const [loadOppUpdate, setLoadOppUpdate] = useState(false);

  const handleClickViewRates = () => {
    setShowDialogViewRates(true);
    setTableEditable(false);
  };

  const onCloseViewRates = () => {
    setShowDialogViewRates(false);
    setTableEditable(false);
  };

  const isClosed = (val) => {
    setEmptyErrMsg(!val);
  };

  useEffect(() => {
    if (loadOpp || loadOppUpdate) {
      setEmptyErrMsg(true);
      setMsgType("success");
      if (loadOpp) setMsgText("Opportunity added successfully.");
      else setMsgText("Data updated successfully.");
      setLoadOpp(false);
      setLoadOppUpdate(false);
      setLoading(true);
      getListOfOpportunityAPI().then((res) => {
        if (res.status === 200) {
          setLoading(false);
          const changedData = JSON.parse(JSON.stringify(res.data));
          changedData.plData.forEach((item) => {
            item.includeInForecastText = item.includeInForecast ? "Yes" : "No";
          });
          setPlData(changedData);
        } else {
          setLoading(false);
          setPlData();
        }
      });
    }
  }, [loadOpp, loadOppUpdate]);

  const loadOpportuityList = () => {
    getListOfOpportunityAPI().then((res) => {
      if (res.status === 200) {
        setLoading(false);
        const changedData = JSON.parse(JSON.stringify(res.data));
        changedData.plData.forEach((item) => {
          item.includeInForecastText = item.includeInForecast ? "Yes" : "No";
        });
        setPlData(changedData);
      } else {
        setLoading(false);
        setPlData();
      }
    });
  };

  useEffect(() => {
    setLoading(true);
    loadOpportuityList();
  }, []);

  return (
    <>
      {/* <span
        style={{
          fontWeight: 600,
          color: "#09659c",
          textDecoration: "underline",
          cursor: "pointer",
        }}
        onClick={handleClickViewRates}
      >
        View Rates
      </span> */}
      {showDialogViewRates && (
        <PipelineRates
          showDialogViewRates={showDialogViewRates}
          onCloseViewRates={onCloseViewRates}
          tableEditable={tableEditable}
          setTableEditable={(val) => setTableEditable(val)}
        />
      )}
      {plData && (
        <PLStatement
          PLData={plData}
          isAddOpp={isAddOpp}
          setIsAddOpp={setIsAddOpp}
          showOpportunityDetails={(val) => showOpportunityDetails(val)}
          loadOpp={(val) => setLoadOpp(val)}
          loadOppUpdate={(val) => setLoadOppUpdate(val)}
          loadOppListForLatestFin={(val) => {
            if (val) loadOpportuityList();
          }}
          onFilteredOppNosChange={onFilteredOppNosChange}
        />
      )}

      {emptyErrMsg && (
        <ActionMessages type={msgType} isClosed={isClosed} message={msgText} />
      )}
      {loading && <Loading />}
    </>
  );
};

export default Pipeline;
